import { FlexV, LineH, StImage } from "../ui/ui"

export const PhotoEl = ({
  url,
  title,
  description,
  size = "80vw",
  maxSize = "80vw",
}: {
  url?: string
  title?: string
  description?: string
  size?: string
  maxSize?: string
}) => {
  return (
    <FlexV
      style={{
        alignItems: "center",
        padding: "2rem",
      }}
    >
      <StImage
        preview
        src={url}
        style={{
          boxShadow: "0px 0px 1rem 0.5rem #0000004D",
          marginBottom: "2rem",
        }}
        pt={{
          image: {
            style: {
              maxWidth: maxSize,
              maxHeight: maxSize,
              width: size,
            },
          },
        }}
      ></StImage>
      <div
        style={{
          fontSize: "1.5rem",
        }}
      >
        {title}
      </div>
      <LineH style={{ width: "60%" }}></LineH>
      <div>{description}</div>
    </FlexV>
  )
}
